import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { start } from '@cartwhl/common/utils/getStartedCookie';
import Text from '@cartwhl/ui/base/Text';

import AuthPageLayout from './AuthPageLayout';
import SignupEmailForm from './SignupEmailForm';
import SignupGoogleForm from './SignupGoogleForm';
import SignupMethodToggle, {
  type SignupMethod,
} from './SignupMethodToggle';

export default function SignupPage() {
  const [signupMethod, setSignupMethod] = useState<SignupMethod>('email');

  useEffect(start, []);

  return (
    <AuthPageLayout title="Create account">
      <SignupMethodToggle value={signupMethod} onChange={setSignupMethod} />

      {signupMethod === 'email' ? <SignupEmailForm /> : <SignupGoogleForm />}

      <Text
        as="div"
        variant="studio/body/sm"
        className="text-gray-45 text-center"
      >
        Have an account?{' '}
        <Link
          to={`/login?${new URLSearchParams(
            window.location.search,
          ).toString()}`}
          className="text-green-50 hover:underline"
        >
          Sign in
        </Link>
      </Text>
    </AuthPageLayout>
  );
}
